module.exports = __webpack_public_path__ + "static/media/Andrew Gibson, Chairman, Wellness Tourism Association.9001a317.png";